import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class AutocompleteVilleComponent extends ShadowDOMElement {
    static className = "AutocompleteVilleComponent";
    
    static properties = {
        apiUrl: { type: String, attribute: "api-url" },
        postalCode: { type: String, attribute: "postal-code" },
        city: { type: String, attribute: "city" },
    };

    constructor() {
        super();
        this.apiUrl = window.APP_URL.api.communeList;
        this._postalCode = "";
        this._city = "";
        this.suggestions = [];
        this.currentIndex = -1;
        this.showDropdown = false;
    }

    connectedCallback() {
        super.connectedCallback();
        // Read initial values from attributes
        const postalCodeAttr = this.getAttribute('postal-code');
        const cityAttr = this.getAttribute('city');
        if (postalCodeAttr) {
            this._postalCode = postalCodeAttr;
        }
        if (cityAttr) {
            this._city = cityAttr;
        }
        // Force update after reading attributes
        this.requestUpdate();
    }
    
    firstUpdated() {
        // After first render, ensure fields have the initial values
        this.updatePostalCodeField();
        this.updateCityField();
    }

    get postalCode() {
        const input = this.shadowRoot?.querySelector("#txtCP");
        return input ? input.value : this._postalCode;
    }

    set postalCode(val) {
        this._postalCode = val;
        this.updatePostalCodeField();
        this.requestUpdate();
    }

    get city() {
        const input = this.shadowRoot?.querySelector("#txtCommune");
        return input ? input.value : this._city;
    }

    set city(val) {
        this._city = val;
        this.updateCityField();
        this.requestUpdate();
    }

    render() {
        return html`
            <div class="row">
                <div class="col-md-4">
                    <label for="txtCP" class="form-label">Code postal *</label>
                    <input
                        type="text"
                        id="txtCP"
                        required
                        @input="${this.handlePostalInput}"
                        @keydown="${this.handleKeydown}"
                        @blur="${this.handleBlur}"
                        autocomplete="new-password"
                        .value="${this._postalCode}"
                    />
                </div>

                <div class="col-md-4">
                    <label for="txtCommune" class="form-label">Commune *</label>
                    <input
                        type="text"
                        id="txtCommune"
                        required
                        autocomplete="new-password"
                        .value="${this._city}"
                    />
                </div>

                ${this.showDropdown && this.suggestions.length > 0
                    ? html`
                        <ul class="dropdown-menu show" style="position: absolute; z-index: 1000; width: 400px">
                            ${this.suggestions.map(
                                (item, index) =>
                                    html`<li
                                        class="dropdown-item ${index === this.currentIndex ? 'active' : ''}"
                                        @mousedown="${() => this.handleSelection(item)}"
                                    >
                                        ${item.name}
                                    </li>`
                            )}
                        </ul>
                    `
                    : ""
                }
            </div>
        `;
    }

    async handlePostalInput(event) {
        this.postalCode = event.target.value;
        if (this.postalCode.length >= 3) {
            try {
                const response = await fetch(`${this.apiUrl}?query=${this.postalCode}`);
                this.suggestions = await response.json();
                this.showDropdown = true;
                this.currentIndex = -1;
            } catch (error) {
                console.error("Error fetching postal code data:", error);
                this.suggestions = [];
                this.showDropdown = false;
            }
        } else {
            this.suggestions = [];
            this.showDropdown = false;
        }
        this.requestUpdate();
    }

    handleKeydown(event) {
        if (this.suggestions.length > 0) {
            switch (event.key) {
                case "ArrowDown":
                    this.currentIndex = (this.currentIndex + 1) % this.suggestions.length;
                    break;
                case "ArrowUp":
                    this.currentIndex =
                        (this.currentIndex - 1 + this.suggestions.length) % this.suggestions.length;
                    break;
                case "Escape":
                    this.showDropdown = false;
                    break;
                case "Enter":
                    if (this.currentIndex >= 0) {
                        this.handleSelection(this.suggestions[this.currentIndex]);
                    }
                    break;
                default:
                    return;
            }
            this.requestUpdate();
        }
    }

    handleBlur() {
        setTimeout(() => {
            this.showDropdown = false;
            this.requestUpdate();
        }, 150);
    }

    handleSelection(item) {
        this.city = item.name;
        this.postalCode = item.value;
        this.showDropdown = false;
        this.requestUpdate();
    }

    updateCityField() {
        const cityInput = this.shadowRoot?.querySelector("#txtCommune");
        if (cityInput) cityInput.value = this._city;
    }

    updatePostalCodeField() {
        const input = this.shadowRoot?.querySelector("#txtCP");
        if (input) input.value = this._postalCode;
    }
}

customElements.define("autocomplete-ville-contact", AutocompleteVilleComponent);
